
import { Link, useNavigate } from 'react-router-dom';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { useAuth } from '@/utils/auth';

export function Header() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/login');
    };

    return (
        <header
            style={{
                backgroundColor: 'var(--color-bg-secondary)',
                borderBottom: '1px solid var(--color-border)',
                padding: 'var(--spacing-md) var(--spacing-xl)',
            }}
        >
            <div className="flex justify-between items-center">
                <Link
                    to="/"
                    style={{
                        fontSize: '1.5rem',
                        fontWeight: 700,
                        textDecoration: 'none',
                        background: 'linear-gradient(135deg, #D63946, #4A90E2)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                >
                    Plotline
                </Link>

                <nav className="flex items-center gap-lg">
                    {user ? (
                        <>
                            <Link to="/dashboard" className="btn-ghost" style={{ padding: 'var(--spacing-sm) var(--spacing-md)' }}>
                                Dashboard
                            </Link>
                            <DropdownMenu.Root>
                                <DropdownMenu.Trigger asChild>
                                    <button
                                        className="flex items-center gap-sm"
                                        style={{
                                            backgroundColor: 'transparent',
                                            border: 'none',
                                            cursor: 'pointer',
                                            padding: 'var(--spacing-sm)',
                                            borderRadius: 'var(--radius-md)',
                                        }}
                                    >
                                        {user.avatarUrl ? (
                                            <img
                                                src={user.avatarUrl}
                                                alt={user.name}
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    borderRadius: '50%',
                                                    border: '2px solid var(--color-primary)',
                                                }}
                                            />
                                        ) : (
                                            <div
                                                style={{
                                                    width: '32px',
                                                    height: '32px',
                                                    borderRadius: '50%',
                                                    backgroundColor: 'var(--color-primary)',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: 600,
                                                    color: 'white',
                                                }}
                                            >
                                                {user.name.charAt(0).toUpperCase()}
                                            </div>
                                        )}
                                        <span style={{ color: 'var(--color-text-primary)' }}>{user.name}</span>
                                    </button>
                                </DropdownMenu.Trigger>
                                <DropdownMenu.Portal>
                                    <DropdownMenu.Content
                                        style={{
                                            backgroundColor: 'var(--color-bg-elevated)',
                                            border: '1px solid var(--color-border)',
                                            borderRadius: 'var(--radius-md)',
                                            boxShadow: 'var(--shadow-lg)',
                                            padding: 'var(--spacing-sm)',
                                            minWidth: '200px',
                                            zIndex: 100,
                                        }}
                                    >
                                        <DropdownMenu.Item asChild>
                                            <Link
                                                to="/settings"
                                                style={{
                                                    display: 'block',
                                                    padding: 'var(--spacing-sm) var(--spacing-md)',
                                                    borderRadius: 'var(--radius-sm)',
                                                    cursor: 'pointer',
                                                    outline: 'none',
                                                    color: 'var(--color-text-primary)',
                                                    textDecoration: 'none',
                                                }}
                                            >
                                                Settings
                                            </Link>
                                        </DropdownMenu.Item>
                                        <DropdownMenu.Separator style={{ height: '1px', backgroundColor: 'var(--color-border)', margin: 'var(--spacing-sm) 0' }} />
                                        <DropdownMenu.Item
                                            onSelect={handleLogout}
                                            style={{
                                                padding: 'var(--spacing-sm) var(--spacing-md)',
                                                borderRadius: 'var(--radius-sm)',
                                                cursor: 'pointer',
                                                outline: 'none',
                                                color: 'var(--color-error)',
                                            }}
                                        >
                                            Logout
                                        </DropdownMenu.Item>
                                    </DropdownMenu.Content>
                                </DropdownMenu.Portal>
                            </DropdownMenu.Root>
                        </>
                    ) : (
                        <>
                            <Link to="/login" className="btn-ghost" style={{ padding: 'var(--spacing-sm) var(--spacing-md)' }}>
                                Login
                            </Link>
                            <Link to="/signup" className="btn-primary" style={{ padding: 'var(--spacing-sm) var(--spacing-lg)' }}>
                                Sign Up
                            </Link>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
}
